
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import MolhamTabs from "components/ReuseableCompos/MolhamTabs";
import TransparencyLayout from "layout/TransparencyLayout";
import useTranslation from "next-translate/useTranslation";
import { useRouter } from "next/router";
import { useCallback, useContext, useEffect, useState } from "react";
import useSWR from "swr";
import NoData from "../../../components/ReuseableCompos/NoData";
import DonationAccordionSkeleton from "../../../components/Skeletons/DonationAccordionSkeleton";
import DatePickerModal from "../../../components/Transparency/TransparencyDetails/DatePickerModal";
import Header from "../../../components/Transparency/TransparencyDetails/Header";
import ReceivedCards from "../../../components/Transparency/TransparencyDetails/ReceivedCards";
import SpentCards from "../../../components/Transparency/TransparencyDetails/SpentCards";
import TransparencyDonationCards from "../../../components/Transparency/TransparencyDonationCards";
import { API_URL } from "../../../config";
import { NavHeaderContext } from "../../../context/NavHeaderContext";
import useModal from "../../../customHooks/useModal";
const TransparencyDetails = () => {
    const { t } = useTranslation("common");
    const router = useRouter();
    const [selectedDate, setSelectedDate] = useState(router.query?.date === undefined
        ? new Date()
        : new Date(dateFormatter(router.query?.date as string)));
    const { showModal: showDatePickerModal, handleCloseModal: handleDatePickerModalClose, handleShowModal: handleDatePickerModalShow, } = useModal();
    const onEditBtnClick = useCallback(() => {
        handleDatePickerModalShow();
    }, [handleDatePickerModalShow]);
    const onSelectedDate = (selectedDate) => {
        setSelectedDate(selectedDate);
        router.replace({
            query: {
                ...router.query,
                date: selectedDate?.toISOString().split("T")[0].replaceAll("-", "")
            }
        }, null, { shallow: true });
        handleDatePickerModalClose();
    };
    useEffect(() => {
        if (!router.query?.date) {
            router.replace({
                query: {
                    ...router.query,
                    date: new Date()?.toISOString().split("T")[0].replaceAll("-", "")
                }
            }, null, { shallow: true });
            return;
        }
        setSelectedDate(new Date(dateFormatter(router.query?.date as string)));
    }, [router]);
    const formattedSelectedDate = selectedDate?.toISOString().split("T")[0];
    const { data, error, isLoading } = useSWR(`${API_URL}/transparency/donations?date=${formattedSelectedDate}`, {
        revalidateOnFocus: false,
        // revalidateOnMount: false,
        revalidateOnReconnect: false,
        refreshWhenOffline: false
    });
    const TransCard = (props) => {
        return (<TransparencyDonationCards data={data} error={error} isLoading={isLoading} {...props}/>);
    };
    const { setHeaderNavMeta } = useContext(NavHeaderContext);
    const { locale } = useRouter();
    useEffect(() => {
        setHeaderNavMeta((prev) => ({
            prev,
            title: t(`donations_record`),
            customSearch: {
                onClick: () => onEditBtnClick(),
                icon: "fe-calendar text-primary fs-xxl"
            }
        }));
        return () => {
            setHeaderNavMeta((prev) => ({
                ...prev,
                title: null,
                customSearch: null
            }));
        };
    }, [locale, onEditBtnClick, setHeaderNavMeta, t]);
    return (<>
      {/* SEO in Layout */}
      <div className="">
        <Header onEditBtnClick={onEditBtnClick} selectedDate={selectedDate}/>
        <div className="d-md-block d-none">
          <TransCard rec spent/>
        </div>
        <MolhamTabs TabsItems={[
            { label: "received_donations", fullWidth: true },
            { label: "spent_donations", fullWidth: true },
        ]}>
          <div>
            <div className="d-md-none d-block  border-bottom">
              <TransCard rec/>
            </div>
            {!!data && data?.received?.count !== 0 ? (<div>
                <ReceivedCards donationType="received" selectedDate={formattedSelectedDate}/>
              </div>) : (<div>
                <>
                  {!data ? (<DonationSkeleton />) : (<div>
                      <div className="d-md-none d-block border-bottom">
                        <TransCard rec/>
                      </div>
                      <NoData />
                    </div>)}
                </>
              </div>)}
          </div>
          <div>
            {!!data && data?.spent?.count !== 0 ? (<div>
                <div className="d-md-none d-block  border-bottom">
                  <TransCard spent/>
                </div>
                <SpentCards selectedDate={formattedSelectedDate}/>
              </div>) : (<div>
                <>
                  {!data ? (<DonationSkeleton />) : (<div>
                      <div className="d-md-none d-block  border-bottom">
                        <TransCard spent/>
                      </div>
                      <NoData />
                    </div>)}
                </>
              </div>)}
          </div>
        </MolhamTabs>
      </div>

      <DatePickerModal handleDatePickerModalClose={handleDatePickerModalClose} showDatePickerModal={showDatePickerModal} onSelectedDate={onSelectedDate}/>
    </>);
};
export default TransparencyDetails;
TransparencyDetails.Layout = TransparencyLayout;
const DonationSkeleton = () => {
    return (<>
      {[0, 0, 0, 0].map((item) => (<DonationAccordionSkeleton key={item}/>))}
    </>);
};
function dateFormatter(date: string) {
    return `${date.slice(0, 4)}-${date.slice(4, 6)}-${date.slice(6, 8)}`;
}

    async function __Next_Translate__getServerSideProps__1a13f66c084__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/transparency/donations/[date]',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || (() => Promise.resolve({})),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__1a13f66c084__ as getServerSideProps }
  